import { useSettingsContext } from '@/context/settings'
import { useDebounce } from '@/hooks/useDebounce'
import { cn } from '@/utils/cn'
import { SECOND_IN_MILLISECONDS } from '@vaultsfyi/common/constants'
import { type HTMLAttributes, useState } from 'react'
import { Button } from '../common/button'
import { ArrowIcon } from '../icons/arrow'
import { TvlRangeSelector } from '../shared/tvlRangeSelector'

interface Props {
  className?: string
  onReturn?: () => void
}

export const TvlSettings = ({ className, onReturn }: Props) => {
  const { tvlRange, handleTvlRange } = useSettingsContext()

  const [sliderTvlRange, setSliderTvlRange] = useState(tvlRange)

  useDebounce(
    () => {
      if (sliderTvlRange !== tvlRange) {
        handleTvlRange(sliderTvlRange)
      }
    },
    [sliderTvlRange, handleTvlRange],
    1 * SECOND_IN_MILLISECONDS
  )

  return (
    <div className={className}>
      <Button
        variant="default"
        className="flex h-12 w-full items-center justify-start gap-2 px-4 py-3"
        onClick={onReturn}
      >
        <ArrowIcon direction="left" />
        <span>TVL settings</span>
      </Button>
      <SettingsItem>
        <span className="text-sm">TVL range, USD</span>
        <TvlRangeSelector initialValue={sliderTvlRange} onChange={setSliderTvlRange} />
      </SettingsItem>
    </div>
  )
}

const SettingsItem = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('flex flex-col items-stretch gap-y-1 border-t px-4 py-3 text-sm', className)} {...props} />
}
